import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/Button";
import { Tooltip } from "@/components/Tooltip";
import { useScrollToSection } from "@/hooks/useScrollToSection";
import { MenuToggle } from "@/layout/MenuToggle";
import { NAVIGATION_ITEMS } from "@/utils/constants";
import { cn } from "@/utils/helpers";
import type { NavigationItem } from "@/utils/interfaces";
import { useEffect, useState } from "react";
interface NavigationItemProps {
  item: NavigationItem;
  isActive: boolean;
  onClick: (sectionId: string) => void;
}
const NavigationItem = t0 => {
  const $ = _c(16);
  const {
    item,
    isActive,
    onClick
  } = t0;
  const t1 = item.label;
  let t2;
  if ($[0] !== item.sectionId || $[1] !== onClick) {
    t2 = () => onClick(item.sectionId);
    $[0] = item.sectionId;
    $[1] = onClick;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = item.icon;
  const t4 = !isActive && "opacity-50";
  let t5;
  if ($[3] !== t4) {
    t5 = cn("w-full! md:w-14! h-14! rounded-xl! md:p-0!", "flex items-center gap-4 md:justify-center", "justify-start px-6 md:px-0", t4);
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = `Navigate to ${item.label}`;
  let t7;
  if ($[5] !== item.label) {
    t7 = <span className="md:hidden">{item.label}</span>;
    $[5] = item.label;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== item.icon || $[8] !== t2 || $[9] !== t5 || $[10] !== t6 || $[11] !== t7) {
    t8 = <Button onClick={t2} variant="primary" icon={t3} className={t5} aria-label={t6}>{t7}</Button>;
    $[7] = item.icon;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== item.label || $[14] !== t8) {
    t9 = <Tooltip content={t1} position="right">{t8}</Tooltip>;
    $[13] = item.label;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};
interface NavigationProps {
  isDrawerOpen: boolean;
  setIsDrawerOpen: (isOpen: boolean) => void;
}
export const Navigation = t0 => {
  const $ = _c(28);
  const {
    isDrawerOpen,
    setIsDrawerOpen
  } = t0;
  const [activeSection, setActiveSection] = useState("");
  const {
    scrollToSection
  } = useScrollToSection();
  let t1;
  if ($[0] !== scrollToSection || $[1] !== setIsDrawerOpen) {
    t1 = sectionId => {
      scrollToSection(sectionId);
      setActiveSection(sectionId);
      setIsDrawerOpen(false);
    };
    $[0] = scrollToSection;
    $[1] = setIsDrawerOpen;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleNavClick = t1;
  let t2;
  if ($[3] !== setIsDrawerOpen) {
    t2 = () => {
      setIsDrawerOpen(false);
    };
    $[3] = setIsDrawerOpen;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleCloseDrawer = t2;
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      let ticking = false;
      const handleScroll = () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            const scrollPosition = window.scrollY + window.innerHeight / 2;
            const heroSection = document.getElementById("hero-section");
            if (heroSection) {
              const {
                offsetTop,
                offsetHeight
              } = heroSection;
              if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
                setActiveSection("");
                ticking = false;
                return;
              }
            }
            for (let i = NAVIGATION_ITEMS.length - 1; i >= 0; i--) {
              const section = document.getElementById(NAVIGATION_ITEMS[i].sectionId);
              if (section) {
                const {
                  offsetTop: offsetTop_0,
                  offsetHeight: offsetHeight_0
                } = section;
                if (scrollPosition >= offsetTop_0 && scrollPosition < offsetTop_0 + offsetHeight_0) {
                  setActiveSection(NAVIGATION_ITEMS[i].sectionId);
                  break;
                }
              }
            }
            ticking = false;
          });
          ticking = true;
        }
      };
      handleScroll();
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t4 = [];
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[7] !== isDrawerOpen || $[8] !== setIsDrawerOpen) {
    t5 = () => {
      if (!isDrawerOpen) {
        return;
      }
      const handleClickOutside = event => {
        const target = event.target as HTMLElement;
        if (!target.closest("nav") && !target.closest("[data-testid=\"menu-toggle-button\"]")) {
          setIsDrawerOpen(false);
        }
      };
      document.addEventListener("click", handleClickOutside);
      return () => document.removeEventListener("click", handleClickOutside);
    };
    t6 = [isDrawerOpen, setIsDrawerOpen];
    $[7] = isDrawerOpen;
    $[8] = setIsDrawerOpen;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  if ($[11] !== handleCloseDrawer || $[12] !== isDrawerOpen) {
    t7 = isDrawerOpen && <div className="fixed inset-0 bg-transparent backdrop-blur-sm z-105 md:hidden" onClick={handleCloseDrawer} aria-hidden="true" />;
    $[11] = handleCloseDrawer;
    $[12] = isDrawerOpen;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = isDrawerOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0";
  let t9;
  if ($[14] !== t8) {
    t9 = cn("fixed left-0 top-0 h-full w-80 z-110 flex flex-col gap-4 p-7", "backdrop-blur-lg md:backdrop-blur-none", "md:bg-transparent shadow-xl", "bg-linear-to-tr from-black/35 to-black/15 md:from-transparent md:to-transparent", "transition-transform duration-300 ease-in-out", "shadow-[inset_-1px_0_16px_rgba(255,255,255,0.2),-1px_0_24px_rgba(255,255,255,0.3),-1px_0_8px_rgba(255,255,255,0.15)]", "md:translate-x-0 md:shadow-none md:w-auto md:p-4 md:top-1/2 md:-translate-y-1/2 md:h-auto md:justify-start", "before:absolute before:right-0 before:top-0 before:h-full before:w-0.5", "before:bg-linear-to-b before:from-white/60 before:via-white/40 before:to-white/60", "before:shadow-[0_0_0.5rem_rgba(255,255,255,0.4),0_0_1rem_rgba(255,255,255,0.3),0_0_1.5rem_rgba(255,255,255,0.2)]", "md:before:hidden", t8);
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== handleCloseDrawer) {
    t10 = <div className="flex justify-end mb-4 md:hidden"><MenuToggle isOpen={true} onToggle={handleCloseDrawer} /></div>;
    $[16] = handleCloseDrawer;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== activeSection || $[19] !== handleNavClick) {
    t11 = NAVIGATION_ITEMS.map(item => {
      const isActive = activeSection === item.sectionId;
      return <NavigationItem key={item.id} item={item} isActive={isActive} onClick={handleNavClick} />;
    });
    $[18] = activeSection;
    $[19] = handleNavClick;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11 || $[23] !== t9) {
    t12 = <nav className={t9}>{t10}{t11}</nav>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t7) {
    t13 = <>{t7}{t12}</>;
    $[25] = t12;
    $[26] = t7;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
};